import React, { Fragment, ReactNode } from "react";
import { Popover as PopoverUI, Transition } from "@headlessui/react";
import MoreIcon from "@/assets/icons/more.svg";
import { Animations } from "./constants";

export interface Props {
  children: ReactNode;
}

const Popover = ({ children }: Props) => {
  return (
    <PopoverUI className="relative flex items-start mt-0.5 justify-center">
      {() => (
        <>
          <PopoverUI.Button className="relative inline-flex items-center justify-center outline-none w-4">
            <MoreIcon className="fill-primary" />{" "}
          </PopoverUI.Button>
          <Transition
            as={Fragment}
            enter={Animations.EaseOut}
            enterFrom={Animations.FadeOut}
            enterTo={Animations.FadeIn}
            leave={Animations.EaseIn}
            leaveFrom={Animations.FadeIn}
            leaveTo={Animations.FadeOut}
          >
            <PopoverUI.Panel className="absolute rounded-2xl border-2 border-primary bg-primary z-50 endemic:border-invert endemic:bg-primary lg:top-8 top-8 -right-2 endemic:text-invert">
              {({ close }) => (
                <PopoverUI onClick={() => close()} className="p-[14px]">
                  {children}
                </PopoverUI>
              )}
            </PopoverUI.Panel>
          </Transition>
        </>
      )}
    </PopoverUI>
  );
};

export default Popover;
